<template>
  <div class="post-page">
    <div class="container post-page__container post-page__container--wide">
      <HcBreadcrumb>
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Featured posts</li>
      </HcBreadcrumb>

      <header class="posts-header hp-animate">
        <h1 class="posts-header__title">Featured posts</h1>
        <p class="posts-header__subtitle">
          Practice tests, hiring challenges, and career resources you can attempt now.
        </p>
      </header>

      <div v-if="loading" class="hp-posts__grid">
        <div class="hp-post-card hp-post-card--skeleton" v-for="n in 6" :key="n">
          <content-loader viewBox="0 0 320 160" primaryColor="#f1f5f9" secondaryColor="#e2e8f0">
            <rect x="0" y="0" rx="4" ry="4" width="80" height="10" />
            <rect x="0" y="24" rx="4" ry="4" width="260" height="16" />
            <rect x="0" y="48" rx="4" ry="4" width="280" height="10" />
            <rect x="0" y="66" rx="4" ry="4" width="240" height="10" />
            <rect x="0" y="130" rx="4" ry="4" width="100" height="10" />
          </content-loader>
        </div>
      </div>

      <div v-else-if="posts.length" class="hp-posts__grid hp-animate">
        <a
          v-for="post in posts"
          :key="post.id || post.post_id"
          :href="getPostLink(post)"
          class="hp-post-card"
          :class="'hp-post-card--' + getPostCategory(post).slug"
        >
          <div v-if="getPostImage(post)" class="hp-post-card__thumb">
            <img :src="getPostImage(post)" :alt="getPostTitle(post)" loading="lazy" />
          </div>
          <div class="hp-post-card__inner">
            <div class="hp-post-card__meta">
              <span class="hp-post-card__tag">{{ getPostCategory(post).label }}</span>
              <span v-if="isRecentPost(post)" class="hp-post-card__tag hp-post-card__tag--new">New</span>
              <span v-if="getPostDuration(post)" class="hp-post-card__read">{{ getPostDuration(post) }}</span>
            </div>
            <h2 class="hp-post-card__title">{{ getPostTitle(post) }}</h2>
            <p class="hp-post-card__desc">{{ getPostExcerpt(post) }}</p>
            <div class="hp-post-card__footer">
              <span v-if="formatPostDate(post)" class="hp-post-card__date">{{ formatPostDate(post) }}</span>
              <span class="hp-post-card__cta">
                {{ getPostCtaLabel(post) }} <span aria-hidden="true">→</span>
              </span>
            </div>
          </div>
        </a>
      </div>

      <div v-else class="posts-empty hp-animate">
        <p>No featured posts found right now. Check back soon.</p>
        <a href="/" class="hp-btn hp-btn--primary" style="margin-top: 1rem;">Back to home</a>
      </div>
    </div>
  </div>
</template>

<script>
import Actions from '../libraries/apiActions.js';
import { ContentLoader } from 'vue-content-loader';
import HcBreadcrumb from '@/components/chrome/HcBreadcrumb.vue';
import {
  getPostTitle,
  getPostCategory,
  getPostCtaLabel,
  getPostImage,
  getPostDuration,
  getPostExcerpt,
  formatPostDate,
  isRecentPost,
  getPostLink,
} from '@/utils/postHelpers';

import '@/assets/home-page.css';
import '@/assets/post-page.css';

export default {
  name: 'Posts',
  components: {
    ContentLoader,
    HcBreadcrumb,
  },
  data() {
    return {
      action: new Actions(),
      posts: [],
      loading: true,
    };
  },
  metaInfo: {
    title: 'Featured posts | Hireclap',
    meta: [
      {
        name: 'description',
        content: 'Browse practice tests, hiring challenges, and featured career resources on Hireclap.',
      },
    ],
  },
  mounted() {
    this.fetchPosts();
    window.scrollTo({ top: 0, behavior: 'auto' });
  },
  methods: {
    fetchPosts() {
      this.loading = true;
      this.action
        .getPosts()
        .then((res) => {
          const posts = (res && (res.posts || res.data || res.result)) || [];
          this.posts = Array.isArray(posts) ? posts : [];
        })
        .catch(() => {
          this.posts = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPostTitle,
    getPostCategory,
    getPostCtaLabel,
    getPostImage(post) {
      return getPostImage(post, this.$S3_url);
    },
    getPostDuration,
    getPostExcerpt,
    formatPostDate,
    isRecentPost,
    getPostLink,
  },
};
</script>
